module.exports = __webpack_public_path__ + "static/media/PublicBgTop.4c1bd23e.svg";